import { IconDefinition } from "./types";

const calendarClock: IconDefinition = {
  iconName: "calendar-clock",
  width: 576,
  height: 512,
  svgPathData:
    "M176 0l0 64 160 0 0-64 48 0 0 64 96 0 0 150c-15.3-3.9-31.4-6-48-6-27.3 0-53.3 5.7-76.9 16l-275.1 0 0 208 162.7 0c2.8 16.8 7.8 32.9 14.8 48l-225.4 0 0-416 96 0 0-64 48 0zm0 112l-96 0 0 64 352 0 0-64-256 0zM288 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-80l-32 0 0 96 80 0 0-32-48 0 0-64z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "calendar-clock",
  unicode: 0xe0d2,
};

export { calendarClock };
